module.exports = __webpack_public_path__ + "media/images/credit-card-payment-logo2-a5b1b9227fc23ab592c8dafba495709c.png";